import axios from 'axios';
import { appConfig } from '../../../../tools/AppConfig';
import delivery from '../../delivery_new';

const COUNTRY_URL = appConfig.getServerUrl();

export const checkProductData = (
  token,
  phone,
  pin,
  integrationId,
  amount
) => {
  return axios
    .post(`${COUNTRY_URL}/api/acceptance/souhoola/paymentlink_check_data?product_token=${token}`, {
      phone_number: phone.slice(2, phone.length),
      pin: pin,
      integration_id: integrationId,
      amount_cents: amount,
      accept_lang: 1,
    })
    .then((res) => res)
    .catch((err) => err.response);
};

export const productTenureInquiry = (
    token,
    downPayment,
    souhoolaToken,
    integration_id,
    deliveryNeed,
    deliveryData,
    userData,
    amountCents,
  ) => {
    return axios
      .post(`${COUNTRY_URL}/product2/${token}`, {
        source: {
            identifier: souhoolaToken,
            subtype: 'SOUHOOLAV2_ONLINE',
            down_payment: downPayment * 100,
            accept_language: 'EN',
          },
          order_data:{
            delivery_needed:deliveryNeed,
            "currency": userData.currency,
            amount_cents:amountCents,
            "shipping_data": {
                "first_name":deliveryData.name.split(" ")[0],
                "last_name":deliveryData.name.split(" ")[1],
                "phone_number": deliveryData.phone,
                "email": deliveryData.email,
                "street": deliveryData.street?deliveryData.street:"NA",
                "city": deliveryData.city?deliveryData.city:"NA",
                "country": deliveryData.country?deliveryData.country:"NA",
                "postal_code": deliveryData.postal_code?deliveryData.postal_code:"Na",
                "state": deliveryData.state?deliveryData.state:"NA"
            },
            "items": [
                {
                    "name": userData.product["product_name"],
                    "amount_cents": userData.product["amount_cents"],
                    "quantity": userData.product["allow_quantity_edit"]?userData.product.quantity:1
                }
            ]
          },
          token: token,
          integration_id
      })
      .then((res) => res)
      .catch((err) => err.response);
  };

export const productChangeInstallment = (
    reference,
    downPayment,
    paymentToken
  ) => {
    return axios
      .post(`${COUNTRY_URL}/api/acceptance/souhoola/change_installment`, {
        "referance": reference,
        "down_payment": downPayment*100,
        "payment_token": paymentToken,
        "accept_lang": 0
      })
      .then((res) => res)
      .catch((err) => err.response);
  };

  export const productInstallmentReview = (
    token,
    months,
    downPayment,
    reference,
    amount
  ) => {
    return axios
      .post(`${COUNTRY_URL}/api/acceptance/souhoola/installment_review`, {
        referance: reference,
        maxMonths: months,
        loanAmount: amount,
        downPayment: downPayment,
        payment_token: token,
        promoCode: 'M',
      })
      .then((res) => res)
      .catch((err) => err.response);
  };
  export const productConfirmInstallment = (
    token,
    souhoolaId,
    reference
  ) => {
    return axios
      .post(`${COUNTRY_URL}/api/acceptance/souhoola/confirm_installment`, {
        referance: reference,
        souhoola_id: souhoolaId,
        payment_token: token,
        accept_lang: 1,
      })
      .then((res) => res)
      .catch((err) => err.response);
  };
  export const productConfirmTransaction = (
    otp,
    token,
    transactionId
  ) => {
    return axios
      .post(`${COUNTRY_URL}/api/acceptance/souhoola/confirm_transaction`, {
        otp: otp,
        payment_token: token,
        transaction_id: transactionId,
      })
      .then((res) => res)
      .catch((err) => err.response);
  };
  
  export const productResendOtp = (token, reference) => {
    return axios
      .post(`${COUNTRY_URL}/api/acceptance/souhoola/resend_otp`, {
        payment_token: token,
        referance: reference,
        accept_lang: 1,
      })
      .then((res) => res)
      .catch((err) => err.response);
  };
  